export const BUZZ_BUZZ_HOME = 'BuzzBuzzHome'
export const REAL_NET = 'RealNet'

export default {
  BUZZ_BUZZ_HOME,
  REAL_NET,
}
